import React, {useEffect } from "react";
import { Modal, Form, Input, Button, notification } from "antd";

const EditModal = ({
  isModalVisible,
  handleOk,
  handleCancel,
  loading,
  initialValues,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue({
        name: initialValues.name,
        description: initialValues.description,
      });
    }
  }, [initialValues, form, isModalVisible]);

  const onFinish = async (values) => {
    const updatedValues = {};

    // Check text fields
    Object.keys(values).forEach((key) => {
      if (values[key] !== initialValues[key]) {
        updatedValues[key] = values[key];
      }
    });

    if (Object.keys(updatedValues).length > 0) {
      await handleOk(initialValues?.id, updatedValues);
    } else {
      notification.error({
        message: "No changes detected",
        duration: 2,
      });
    }
  };

  return (
    <Modal
      title="Edit Master Tags"
      open={isModalVisible}
      footer={null}
      onCancel={() => {
        handleCancel();
        form.resetFields();
      }}
      maskClosable={false}
    >
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item
          name="name"
          label="Tag Name"
          rules={[{ required: true, message: "Please enter Tag Name", whitespace: true }]}
        >
          <Input placeholder="Enter master tag name" maxLength={50} showCount/>
        </Form.Item>
        <Form.Item
          name="description"
          label="Description"
          rules={[{ required: false, message: "Please input the description!", whitespace: true }]}
        >
          <Input.TextArea rows={3} placeholder="Enter description" maxLength={50} showCount />
        </Form.Item>

        <Form.Item>
          <div className="flex items-center justify-end gap-4">
            <Button onClick={handleCancel}>Cancel</Button>
            <Button type="primary" htmlType="submit" loading={loading}>
              Save Changes
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditModal;
